import React from "react";
import { DoughnutChartTemplate } from "themes/common/components";

function DoughnutChart(props) {
    return <DoughnutChartTemplate {...props} />;
}

export default DoughnutChart;
